import type { Mode, SchemaTapGrid } from '../schema/types'

/**
 * Pure hit-test: returns the stationId of the first [TapGrid] whose rect
 * contains ([canvasX], [canvasY]) and whose modes include [mode]. Null
 * when no grid matches. Iteration order follows [tapGrids], which is
 * `schema.json` order.
 *
 * Edge rule: top-left inclusive, bottom-right exclusive (standard CSS
 * pixel rule). See spec §5.
 */
export function hitTest(
  canvasX: number,
  canvasY: number,
  mode: Mode,
  tapGrids: readonly SchemaTapGrid[],
): string | null {
  for (const g of tapGrids) {
    if (!g.modes.includes(mode)) continue
    const left = g.origin.x
    const top = g.origin.y
    const right = left + g.size.width
    const bottom = top + g.size.height
    if (canvasX >= left && canvasX < right && canvasY >= top && canvasY < bottom) {
      return g.stationId
    }
  }
  return null
}
